const en = {
  navBar: {
    homePage: "HOME",
    gowy: "ENTER WEIYING",
    // summarize: "summarize",
    Cultural: "CULTURE",
    honor: "HONOR",
    Product: "PRODUCT",
    message: "ADDRESS",
    concat: "CONTACT US",
    about: "ABOUT US",
    lang: "LANGUAGE",
    en: "ENGLISH",
    cn: "CHINESE",
    phone: "Admin",
    fax: "Sales",
    address: "Address",
    "address-desc":
      "82 Haoshan Road, High tech Industrial Development Zone, Weihai City, Shandong Province, China",
    Copyright:
      "© Copyright Weihai Weiying Tool Co., Ltd.. 2012-2013 Filing Information: Lu ICP Bei No. 12011979",
  },
  rightFloat: {
    wechat: "WeChat",
    official: "WeChat official account",
    phone: "Phone",
    backTop: "TOP",
  },
  inWeiying: {
    Product: "Product Center",
    gowy: "ENTERING WEIYING",
    "wy-desc":
      "Weihai Weiying Tool Co., Ltd. was established in 2000, focusing on the research and production of ultrahard materials (such as PCD and CBN) and special carbide tools. The company owns a factory covering 30,000 square meters and more than 300 sets of advanced equipment from both domestic and international sources, forming a comprehensive tool production line. Its R&D team that led by cutting tool experts with 30 years of experience, has high technical expertise and experienced technicians.",
    brief:
      "Persevere, innovate, and build dreams. Weiying Tool will join hands with you, striving for excellence like a diamond, achieving harmony between heaven, earth, and humanity, and creating a brilliant future together!",
    viewMore: "view More",
    partner: "PARTNER",
  },
  honor: {
    honor: "HONOR",
    title1: "National High-tech Enterprise",
    desc1:
      "The recognition standards for national high-tech enterprises usually include aspects such as technological innovation capability, research and development investment, intellectual property rights, and the transformation of scientific and technological achievements. By meeting these standards, Weiying Tool has been recognized as a national high-tech enterprise.",
    title2: "Obtained ISO 9001:2015 Quality Management System Certification",
    desc2:
      "The ISO 9001:2015 Quality Management System Certification covers the design, development, production, and sales aspects of Weiying Tool Company's quality management system, ensuring that the company can provide products and services that meet quality standards throughout the entire value chain.",
  },
  area: {
    area: "APPLICATION AREA",
    "area-desc":
      "The products of Weiying Tool company play an important role in various fields, providing high-quality solutions for the processing needs of different industries",
    car: "Automotive Manufacturing Field",
    "car-desc":
      "In the field of automotive manufacturing, the products of Weiying Tool are widely used for processing automotive engines and their components. Our cutting tools can achieve efficient, high-speed, and high-precision processing, and are able to improve the production efficiency and product quality.",
    aviation: "Aerospace Field",
    "aviation-desc":
      "In the aerospace field, the cutting tools of Weiying Tool also play important roles. They are used for processing aerospace components such as engine parts, wing structures, etc. These cutting tools need to have high wear resistance, high cutting performance, and stability to meet the strict quality and safety requirements of the aerospace industry.",
    electron: "Electronic Field",
    "electron-desc":
      "In the field of electronic, products from Weiying Tool are used for processing electronic equipment casings, heat sinks, and other components as well as manufacturing electronic components. These cutting tools need to have precision machining capabilities to ensure the quality and performance of electronic products.",
    medical: "Medical Field",
    "medical-desc":
      "In the medical field, Weiying Tool’s products are used for processing components of medical equipment, such as surgical instruments, implants, etc. These kinds of cutting tools need to have high precision and cleanliness to ensure the safety and effectiveness of medical equipment.",
    current: "General Components",
    "current-desc":
      "Weiying Tool has products that can be used for processing various general Components as well, such as bearings, gears, etc. These kinds of cutting tools need to adapt to the processing needs of different materials and shapes, and to ensure the quality and performance of common components.",
  },
  company: {
    company: "Weihai Weiying Tool Co., Ltd.",
    what_company: "What is Weihai Weihard Tools Co., Ltd",
    desc1:
      "Weihai Weiying Tool Co., Ltd. was established in 2000, focusing on the research and production of ultrahard materials (such as PCD and CBN) and special carbide tools. The company owns a factory covering 30,000 square meters and more than 300 sets of advanced equipment from both domestic and international sources, forming a comprehensive tool production line. Its R&D team that led by cutting tool experts with 30 years of experience, has high technical expertise and experienced technicians.",
    desc2:
      "The company mainly produces PCD cutting tool, CBN cutting tool, carbide cutting tool and complex HSS tool, forming a seriation and scale manufacturing service system.",
    desc3:
      "The product range includes turning and boring cutters, slot cutters, machining hardened steel cutters, angle forming cutters, high-speed milling inserts, milling cutters, indexable inserts and cutters, high-precision composite rotary cutters, carbide special cutters, etc. It can be applied to new energy vehicles, passenger vehicles, commercial vehicle manufacturing, consumer electronics industry, aerospace, heavy industry, etc.",
  },
  service: {
    service: "SERVICE ADVANTAGES",
    desc: "Weiying Tool is committed to providing customized solutions for customers",
    advantage1:
      "Provide customers with comprehensive technical support from the overall tool solution of turn-key machine tool projects to service and site commissioning",
    advantage2:
      "Stable product quality, research details, improve details and continuously improve product quality",
    advantage3:
      "Continuously optimize the tool performance, enhance the efficiency, improve the machining accuracy and reduce the single-piece cost for customers",
    advantage4:
      "Fast response speed and short supply period. Take the urgent needs of customers as ours, establish emergency green channels to achieve fast supply",
    advantage5:
      "Solve processing difficulties for customers through tool research and provide technical support for customers",
  },
  experience: {
    title: "DEVELOPMENT HISTORY",
    desc: "Over the past 20 years of development, Weiying Tool has been committed to technological innovation and product optimization.",
  },
  culture: {
    title: "COMPANY CULTURE",
    desc: "With continuous self-renewal, Weiying Tool will make great achievements. ",
    "culture-title1": "Our Vision",
    "culture-content1":
      "Make every car in the world bear a Weiying’s stamp - all for this dream! ",
    "culture-title2": "Our Spirit",
    "culture-content2": "Self-improvement without stop",
    "culture-title3": "Our Slogan",
    "culture-content3": "Persevere, innovate, and build dreams.",
    honor: "HONOR",
    desc2:
      "Over the past 20 years of development, Weiying Tool has been committed to technological innovation and product optimization.",
  },
  Product: {
    Location: "Location",
    title: "Product Center",
    desc: "Provide high-end precision cutting tools and cutting solutions for the global manufacturing market",
    quotation: "Request for quotation",
    download: "Data download",
    "shop-desc": "PRODUCT INTRODUCTION",
    callTime: "24-hour national consultation hotline",
    understand: "Learn more",
  },
  msg: {
    title: "MESSAGE",
    time: "24/7 online, dedicated to serving you",
    desc: "Fill in the following information and we will contact you as soon as possible. (Strictly protect the information from leakage, please fill in with confidence.)",
    youName: "Your Name",
    placeholderName: "Please enter your name",
    youPhone: "Your Phone",
    placeholderPhone: "Please enter your phone number",
    type: "Product Type",
    placeholderType: "Please select product type",
    demand: "Your Demand",
    placeholderDemand: "Please enter your requirements",
    submit: "Submit requirement proposal",
    contcat: "Contact Us",
    phone: "Phone：",
    information: "Information",
    product:'Product',
    lx:'Information:',
    fax:'Fax',
    email: "E-mail",
    address: "Address",
    "address-detail":
      "82 Haoshan Road, High tech Industrial Development Zone, Weihai City, Shandong Province, China",
    communicate: "Online communication with technical consultants",
    "communicate-btn": "Immediate online consultation",
  },
  contact: {
    company: "Weihai Weiying Tool Co., Ltd.",
    address:
      "82 Haoshan Road, High tech Industrial Development Zone, Weihai City, Shandong Province, China",
    phone: "Phone：",
    Navigation: "Navigation Now",
  },
  diaLog: {
    Cancel: "Cancel",
    Confirm: "Confirm",
    title: "contact information",
  },
};
export default en;
